import type { ToneSignatureResultDto, ToneSignatureUiCategory, ToneSignatureUiModel } from '../models/toneSignature'

export function toToneSignatureUiModel(dto: ToneSignatureResultDto): ToneSignatureUiModel {
  const categories = dto.categories
    .map<ToneSignatureUiCategory>((category) => ({
      category: category.category,
      elements: [
        ...category.primaryElements,
        ...category.alternatives,
        ...category.contextElements,
        ...category.recreationHints,
      ].map((element) => ({
        ...element,
        category: category.category,
      })),
    }))
    .filter((category) => category.elements.length > 0)

  return {
    songId: dto.songId,
    title: dto.songTitle,
    artist: dto.artistName,
    confidence: dto.overallConfidence,
    confidenceBand: dto.overallConfidenceBand,
    synthesisVersion: dto.synthesisVersion,
    categories,
    evidenceSummary: dto.evidenceSummary,
  }
}
